(ns app.front.view.map-common.info-box
  (:require ["@carbon/icons-react/es/close--filled/16" :default CloseFilled16]
            [core.front.carbon :as cc]
            [core.front.icons :as i]))


(defn right-side-box [{:keys [tr on-cancel-click on-back-click]} & content]
  [:div.map-common-info-box.rounded.bg-ui-blue-10.w-full.mt-6.lg:w-1-2.pl-2.pr-2.py-2.lg:ml-2.flex.flex-col.justify-between
   [:div.flex.items-center.mb-3.map-right-side-box
    {:class (if on-back-click "justify-between" "justify-end")}
    (when on-back-click
      (cc/button {:icon          i/chevron-left
                  :icon-position :left
                  :class-name    "tight-icon-left-button"
                  :kind          :ghost
                  :size          :small
                  :on-click      on-back-click}
                 (tr [:back])))
    (cc/button {:icon     CloseFilled16
                :kind     :ghost
                :size     :small
                :on-click on-cancel-click}
               (tr [:close]))]
   (into [:<>] content)])
